export default "__VITE_ASSET__56023cb9__"